// extracted by mini-css-extract-plugin
export var label = "_bh-5";
export var slideContainer = "_bh-0";
export var slider = "_bh-1";
export var sliderLg = "_bh-4";
export var sliderMd = "_bh-3";
export var sliderSm = "_bh-2";